// Mock data for Complanet clone (Modern IT Services Layout)

export const siteData = {
  brand: "comPLANET",
  tagline: "THE FUTURE OF HUMANITY IN IT SERVICE",

  images: {
    hero: "https://images.pexels.com/photos/30596291/pexels-photo-30596291.png",
    team: "https://images.pexels.com/photos/3180831/pexels-photo-3180831.jpeg",
    security: "https://images.unsplash.com/photo-1465101162946-4377e57745c3?crop=entropy&cs=srgb&fm=jpg&q=85",
    cloud: "https://images.unsplash.com/photo-1454789548928-9efd52dc4031?crop=entropy&cs=srgb&fm=jpg&q=85",
  },

  nav: [
    { label: "Home", to: "/" },
    { label: "Services", to: "/service" },
    { label: "Ideas", to: "/ideas" },
    { label: "About", to: "/about" },
    { label: "Contact", to: "/contact" },
  ],

  hero: {
    eyebrow: "NO FIX \u2014 NO FEE",
    heading: "IT services engineered for humans, not just machines.",
    subheading:
      "From ransomware recovery to Microsoft 365, Azure and network design \u2014 Complanet delivers fast, reliable IT services devoted to client satisfaction.",
    ctaPrimary: "Get a free consultation",
    ctaSecondary: "Explore services",
    stats: [
      { value: "15+", label: "Years in IT" },
      { value: "350+", label: "Businesses served" },
      { value: "24/7", label: "Support coverage" },
      { value: "98%", label: "Retention rate" },
    ],
  },

  services: {
    heading: "What we do",
    intro:
      "A full-stack IT partner \u2014 from a single workstation to enterprise infrastructure. We keep your business running so you can focus on growing it.",
    items: [
      { title: "Computer & Server Support", desc: "Day-to-day management, hardware & software issue resolution, and proactive maintenance.", icon: "Cpu" },
      { title: "Networking & Infrastructure", desc: "Design, install and maintain reliable wired and wireless networks that scale with you.", icon: "Network" },
      { title: "Microsoft 365 & Azure", desc: "Cloud migration, licensing, identity and collaboration across the Microsoft stack.", icon: "Cloud" },
      { title: "Cybersecurity & Recovery", desc: "Ransomware response, backups, disaster recovery and hardened security policies.", icon: "ShieldCheck" },
      { title: "VoIP & Broadband", desc: "Internet phones, phone-line rental and business broadband tuned for uptime.", icon: "Phone" },
      { title: "Web, Domains & Email", desc: "Hosting, domain registration and email systems your team can actually rely on.", icon: "Globe" },
    ],
  },

  approach: {
    eyebrow: "OUR APPROACH",
    heading: "Get the full benefit of the technology you invested in.",
    body: [
      "Many businesses fail to unlock the value of the tech they already own. We work alongside your team to build a clear IT strategy, then implement it \u2014 without the jargon.",
      "Whether you need help delivering an existing roadmap or bringing an idea to life, we plug in the skills your business is missing.",
    ],
    bullets: [
      "IT strategy & consulting",
      "Compliance, IT security & governance",
      "Industry best-practice approach",
      "Hands-on implementation, not just advice",
    ],
  },

  security: {
    eyebrow: "CYBERSECURITY",
    heading: "Recover fast. Stay online. Sleep at night.",
    body: "From a suspicious email to a full-blown ransomware attack, our team is trained to respond with speed and clarity \u2014 restoring data, systems and confidence.",
    bullets: [
      "Ransomware response & recovery",
      "Automated cloud & on-prem backups",
      "Firewall, endpoint and email security",
      "Business continuity planning",
    ],
  },

  testimonials: {
    heading: "Trusted by teams across the UK",
    items: [
      {
        quote:
          "Complanet rescued us from a ransomware attack in under 12 hours. We didn\u2019t lose a single client file. They\u2019ve been our IT team ever since.",
        author: "Sarah W.",
        role: "Operations Director, Southampton",
      },
      {
        quote:
          "Migrated 40 users to Microsoft 365 without a single support ticket from staff. That\u2019s never happened to us before.",
        author: "James P.",
        role: "Managing Partner, Legal firm",
      },
      {
        quote:
          "They actually explain things in plain English. Our whole team finally understands what our IT setup does.",
        author: "Priya K.",
        role: "Founder, Marketing agency",
      },
    ],
  },

  cta: {
    heading: "Let\u2019s make your IT boring \u2014 in the best possible way.",
    body: "Book a free 30-minute call. We\u2019ll review what you have, spot the risks, and suggest what to fix first.",
    button: "Talk to an engineer",
  },

  contact: {
    heading: "Get in touch",
    intro:
      "Tell us what\u2019s not working \u2014 or what you\u2019d like to work better. We reply within one working day.",
    columns: [
      { title: "General", lines: ["adamn1224@gmail.com", "07713 233 069"] },
      { title: "Sales", lines: ["adamn1224@gmail.com"] },
      { title: "Address", lines: ["76, King Georges Avenue", "SO15 4JY Southampton", "Hampshire, UK"] },
    ],
  },

  about: {
    title: "About Complanet",
    lead:
      "A UK-based IT services company committed to fast, reliable and human-first computing solutions.",
    paragraphs: [
      "Complanet LTD supports businesses across the UK with everything from workstation troubleshooting to full enterprise infrastructure. Our philosophy is simple: NO FIX \u2014 NO FEE. We stand behind every job.",
      "We treat every client system like our own. That means clear communication, no jargon, and answers to the question you actually asked.",
    ],
    values: [
      { title: "Human first", desc: "Real people, real answers \u2014 no ticket black holes." },
      { title: "No fix, no fee", desc: "If we can\u2019t solve it, you don\u2019t pay for it." },
      { title: "Full-stack", desc: "From printers to Azure \u2014 one partner for all IT." },
    ],
  },

  ideas: {
    title: "Ideas & IT Strategy",
    lead: "Turning technology from a cost centre into a growth engine.",
    paragraphs: [
      "Many businesses, regardless of size or sector, fail to get the full benefit of the technology they have invested in. Don\u2019t let that be your business.",
      "Every business is different, with its own unique technology requirements. You may already have an IT strategy in place, but need help implementing it \u2014 or a project on the horizon and no in-house skills to deliver it.",
      "IT transformation is challenging, but with the right advice, guidance and best-practice approach, you can meet your compliance, security and governance goals with confidence.",
    ],
  },

  footer: {
    tagline: "Fast computing services devoted to client satisfaction.",
    columns: [
      {
        title: "Services",
        links: ["Computer support", "Networking", "Microsoft 365", "Cybersecurity", "Cloud & Azure"],
      },
      {
        title: "Company",
        links: ["About", "Ideas", "Contact"],
      },
      {
        title: "Contact",
        links: ["adamn1224@gmail.com", "07713 233 069", "Southampton, UK"],
      },
    ],
    copyright: "\u00a9 2025 Complanet LTD. All rights reserved.",
  },

  cookie: {
    text: "We use cookies on our website to see how you interact with it. By accepting, you agree to our use of such cookies.",
    linkLabel: "Privacy Policy",
  },
};
